import React, { PureComponent } from "react";
import "./breadcrumbs.css";

export default class Breadcrumbs extends PureComponent {
    static get propTypes() {
        return {
            children: React.PropTypes.oneOfType([
                React.PropTypes.array,
                React.PropTypes.element
            ]).isRequired,
        };
    }

    render() {
        return (
            <div className="appointment-breadcrumbs">
                {this.props.children}
            </div>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/widgets/appointment-widget/components/breadcrumbs.js
 **/